export default "__VITE_ASSET__CUITBwLq__"